import { Component } from '@angular/core';

@Component({
  selector: 'app-toast-types',
  template: '',
  styleUrls: ['./toast-types.component.scss']
})
export class ToastTypesComponent {
  public title: string;
  public subtitle: string;
}

@Component({
  selector: 'app-toast-success',
  templateUrl: './templates/toast-success.component.html',
  styleUrls: ['./toast-types.component.scss']
})
export class ToastSuccessComponent extends ToastTypesComponent { }

@Component({
  selector: 'app-toast-warning',
  templateUrl: './templates/toast-warning.component.html',
  styleUrls: ['./toast-types.component.scss']
})
export class ToastWarningComponent extends ToastTypesComponent { }

@Component({
  selector: 'app-toast-error',
  templateUrl: './templates/toast-error.component.html',
  styleUrls: ['./toast-types.component.scss']
})
export class ToastErrorComponent extends ToastTypesComponent { }
